import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './style.css';

const NodeConnection = ({ id, idA, idB }) => {

    const nodeA = useSelector( state => state.board.nodes[ idA ] ),
    nodeB = useSelector( state => state.board.nodes[ idB ] ),
    halfNodeWidth = 300,
    halfNodeHeight = 35,
    [ endX, setEndX ] = useState( nodeB.x + halfNodeWidth ),
    [ endY, setEndY ] = useState( nodeB.y + halfNodeHeight ),
    [ startX, setStartX ] = useState( nodeA.x + halfNodeWidth ),
    [ startY, setStartY ] = useState( nodeA.y + halfNodeHeight );

    /**
     * @name updateCoords
     * @function
     * @description Updates coordinates for the node connector
     */
    const updateCoords = useCallback( ( setX, setY ) => mutations => {

        const { attributeName, target } = mutations[ 0 ],
        value = target[ attributeName ].baseVal[ 0 ].matrix; 
                
        setX( value.e + halfNodeWidth );
        setY( value.f + halfNodeHeight );

    }, []);

    /**
     * @name mount
     * @function
     * @description mounts an observer to the provided ID
     * @param {string} nodeId ID of the node to observe
     * @param {function} setX Function to set the X coord
     * @param {function} setY Function to set the Y coord
     * @returns {MutationObserver}
     */
    const mount = useCallback(( nodeId, setX, setY ) => {

        const observer = new MutationObserver( updateCoords( setX, setY ) ),
        node = document.getElementById( nodeId );

        observer.observe( node, { 
            attributes: true,
            attributeFilter: [ 'transform' ]
        });

        return observer;

    }, [ updateCoords ]);


     // Watch nodes for updates
    useEffect(() => {

        const observers = [ 
            mount( idA, setStartX, setStartY ),
            mount( idB, setEndX, setEndY )
        ];

        return () => {
            observers.forEach( observer => {
                observer.disconnect()
            });
        }

    }, [ idA, setStartX, setStartY, idB, setEndX, setEndY, mount ]);

    return (
        <line id={ id } x1={ startX } y1={ startY } x2={ endX  } y2={ endY } className="coe__nodeConnection" />
    )

}

NodeConnection.propTypes = {
    id: PropTypes.string.isRequired,
    idA: PropTypes.string.isRequired,
    idB: PropTypes.string.isRequired
}

export default NodeConnection